import { Icon } from "@chakra-ui/react";

// SVG Icons

export const HomeIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 26V16.8235H18V26H25.5V13.7647H30L15 0L0 13.7647H4.5V26H12Z"
      fill="#141D43"
    />
  </Icon>
);

export const FarmerIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2499 3.75335C21.2499 3.91907 21.184 4.07808 21.0668 4.19525C20.9496 4.31243 20.7906 4.37834 20.6248 4.37834H19.3749V6.87808C19.3749 8.44109 18.541 9.88482 17.1873 10.6663C15.8337 11.4478 14.166 11.4478 12.8124 10.6663C11.4587 9.88482 10.6248 8.44088 10.6248 6.87787V4.37834H9.37486C9.02979 4.37834 8.74979 4.09838 8.74979 3.75335C8.74979 3.40832 9.02979 3.12836 9.37486 3.12836H10.806C11.1666 1.9154 12.0348 0.917759 13.1868 0.393417C14.3386 -0.131139 15.6611 -0.131139 16.8129 0.393417C17.9649 0.917765 18.8331 1.9154 19.1937 3.12836H20.6248C20.7906 3.12836 20.9496 3.19427 21.0668 3.31145C21.184 3.42862 21.2499 3.58763 21.2499 3.75335ZM19.5499 12.502H18.7498V20.001H19.0374C19.2238 20.001 19.3749 20.1521 19.3749 20.3385V30H20.6248V13.5771C20.6248 13.2921 20.5116 13.0186 20.3099 12.8171C20.1084 12.6156 19.8349 12.502 19.5499 12.502ZM12.4999 20.001H17.4998L17.5 12.502H12.4999L12.4999 20.001ZM9.37497 13.5771V29.9999H10.6249V20.3385C10.6249 20.1521 10.776 20.001 10.9624 20.001H11.25V12.502H10.4499C10.1649 12.502 9.89139 12.6154 9.68986 12.8169C9.48813 13.0184 9.37497 13.2921 9.37497 13.5771ZM4.49998 13.8771C4.91244 13.4647 4.99991 11.8774 4.99991 11.8774C4.99991 11.8774 3.41243 11.9649 2.99999 12.3773C2.91859 12.4689 2.85497 12.5748 2.81249 12.6897V11.2525H2.18742V12.6897C2.14494 12.5748 2.08132 12.4689 1.99992 12.3773C1.58747 11.9649 0 11.8774 0 11.8774C0 11.8774 0.0874711 13.4647 0.499927 13.8771C1.0122 14.1815 1.59208 14.3533 2.18742 14.377V16.4392C2.14494 16.3243 2.08132 16.2185 1.99992 16.1268C1.58747 15.7144 0 15.627 0 15.627C0 15.627 0.0874711 17.2142 0.499927 17.6266C1.0122 17.9311 1.59208 18.1028 2.18742 18.1265V20.1887C2.14494 20.0738 2.08132 19.968 1.99992 19.8763C1.58747 19.4639 0 19.3765 0 19.3765C0 19.3765 0.0874711 20.9637 0.499927 21.3761C1.0122 21.6806 1.59208 21.8523 2.18742 21.876V23.9382C2.14494 23.8234 2.08132 23.7175 1.99992 23.6258C1.58747 23.2134 0 23.126 0 23.126C0 23.126 0.0874711 24.7132 0.499927 25.1256C1.0122 25.4301 1.59208 25.6019 2.18742 25.6255V30H2.81249V25.6255C3.40574 25.6094 3.98559 25.4462 4.49998 25.1505C4.91244 24.7381 4.99991 23.1509 4.99991 23.1509C4.99991 23.1509 3.41243 23.2383 2.99999 23.6507C2.91859 23.7424 2.85497 23.8485 2.81249 23.9633V21.876C3.40574 21.8599 3.98559 21.6967 4.49998 21.401C4.91244 20.9886 4.99991 19.4013 4.99991 19.4013C4.99991 19.4013 3.41243 19.4888 2.99999 19.9012C2.91859 19.9929 2.85497 20.0989 2.81249 20.2138V18.1265C3.40574 18.1103 3.98559 17.9471 4.49998 17.6515C4.91244 17.2391 4.99991 15.6518 4.99991 15.6518C4.99991 15.6518 3.41243 15.7393 2.99999 16.1517C2.91859 16.2433 2.85497 16.3494 2.81249 16.4643V14.3769C3.40783 14.3533 3.9879 14.1815 4.49998 13.8771ZM29.5001 13.8771C29.9125 13.4647 30 11.8774 30 11.8774C30 11.8774 28.4125 11.9649 28.0001 12.3773C27.9187 12.4689 27.8551 12.5748 27.8126 12.6897V11.2525H27.1875V12.6897C27.145 12.5748 27.0814 12.4689 27 12.3773C26.5876 11.9649 25.0001 11.8774 25.0001 11.8774C25.0001 11.8774 25.0876 13.4647 25.5 13.8771C26.0144 14.1728 26.5943 14.336 27.1875 14.3521V16.4392C27.145 16.3243 27.0814 16.2185 27 16.1268C26.5876 15.7144 25.0001 15.627 25.0001 15.627C25.0001 15.627 25.0876 17.2142 25.5 17.6266C26.0144 17.9223 26.5943 18.0855 27.1875 18.1016V20.1887C27.145 20.0739 27.0814 19.968 27 19.8763C26.5876 19.4639 25.0001 19.3765 25.0001 19.3765C25.0001 19.3765 25.0876 20.9638 25.5 21.3762C26.0144 21.6718 26.5943 21.835 27.1875 21.8511V23.9383C27.145 23.8234 27.0814 23.7175 27 23.6259C26.5876 23.2135 25.0001 23.126 25.0001 23.126C25.0001 23.126 25.0876 24.7133 25.5 25.1257C26.0144 25.4213 26.5943 25.5845 27.1875 25.6006V29.9751H27.8126V25.6255C28.4056 25.6094 28.9855 25.4462 29.5001 25.1506C29.9125 24.7382 30 23.1509 30 23.1509C30 23.1509 28.4125 23.2384 28.0001 23.6508C27.9187 23.7424 27.8551 23.8485 27.8126 23.9634V21.876C28.4056 21.8599 28.9855 21.6967 29.5001 21.4011C29.9125 20.9886 30 19.4014 30 19.4014C30 19.4014 28.4125 19.4888 28.0001 19.9012C27.9187 19.9929 27.8551 20.099 27.8126 20.2138V18.1265C28.4056 18.1104 28.9855 17.9472 29.5001 17.6515C29.9125 17.2391 30 15.6519 30 15.6519C30 15.6519 28.4125 15.7393 28.0001 16.1517C27.9187 16.2434 27.8551 16.3495 27.8126 16.4643V14.377C28.4079 14.3533 28.9878 14.1815 29.5001 13.8771Z"
      fill="#141D43"
    />
  </Icon>
);

export const InventoryIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2 0H2.8C1.4 0 0 1.26 0 2.8V7.014C0 8.022 0.602 8.89 1.4 9.38V25.2C1.4 26.74 2.94 28 4.2 28H23.8C25.06 28 26.6 26.74 26.6 25.2V9.38C27.398 8.89 28 8.022 28 7.014V2.8C28 1.26 26.6 0 25.2 0ZM18.2 16.8H9.8V14H18.2V16.8ZM25.2 7H2.8V2.8L25.2 2.772V7Z"
      fill="#141D43"
    />
  </Icon>
);

export const ProcurementIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6667 0H3.33333C1.5 0 0 1.5 0 3.33333V26.6667C0 28.5 1.5 30 3.33333 30H26.6667C28.5 30 30 28.5 30 26.6667V3.33333C30 1.5 28.5 0 26.6667 0ZM18.3333 23.3333H6.66667V20H18.3333V23.3333ZM23.3333 16.6667H6.66667V13.3333H23.3333V16.6667ZM23.3333 10H6.66667V6.66667H23.3333V10Z"
      fill="#141D43"
    />
  </Icon>
);

export const CertificateIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 28 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 0H3.5C1.575 0 0.0175004 1.575 0.0175004 3.5L0 31.5C0 33.425 1.5575 35 3.4825 35H24.5C26.425 35 28 33.425 28 31.5V10.5L17.5 0ZM21 28H7V24.5H21V28ZM21 21H7V17.5H21V21ZM15.75 12.25V2.625L25.375 12.25H15.75Z"
      fill="#141D43"
    />
  </Icon>
);

export const ProfileIcon = (props) => (
  <Icon
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.33333V26.6667C0 28.5 1.48333 30 3.33333 30H26.6667C28.5 30 30 28.5 30 26.6667V3.33333C30 1.5 28.5 0 26.6667 0H3.33333C1.48333 0 0 1.5 0 3.33333ZM20 10C20 12.7667 17.7667 15 15 15C12.2333 15 10 12.7667 10 10C10 7.23333 12.2333 5 15 5C17.7667 5 20 7.23333 20 10ZM5 23.3333C5 20 11.6667 18.1667 15 18.1667C18.3333 18.1667 25 20 25 23.3333V25H5V23.3333Z"
      fill="#141D43"
    />
  </Icon>
);

export const SearchIcon = (props) => (
  <Icon
    width="7"
    height="7"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.146 12.371 1.888 11.113C0.629333 9.85433 0 8.31667 0 6.5C0 4.68333 0.629333 3.14567 1.888 1.887C3.146 0.629 4.68333 0 6.5 0C8.31667 0 9.85433 0.629 11.113 1.887C12.371 3.14567 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.81267 10.5627 9.688 9.688C10.5627 8.81267 11 7.75 11 6.5C11 5.25 10.5627 4.18733 9.688 3.312C8.81267 2.43733 7.75 2 6.5 2C5.25 2 4.18733 2.43733 3.312 3.312C2.43733 4.18733 2 5.25 2 6.5C2 7.75 2.43733 8.81267 3.312 9.688C4.18733 10.5627 5.25 11 6.5 11Z"
      fill="#B8DEF8"
    />
  </Icon>
);

export const DownloadIcon = (props) => (
  <Icon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 11.575C7.86667 11.575 7.74167 11.554 7.625 11.512C7.50833 11.4707 7.4 11.4 7.3 11.3L3.7 7.7C3.51667 7.51667 3.425 7.28333 3.425 7C3.425 6.71667 3.51667 6.48333 3.7 6.3C3.88333 6.11667 4.12067 6.02067 4.412 6.012C4.704 6.004 4.94167 6.09167 5.125 6.275L7 8.15V1C7 0.716667 7.096 0.479 7.288 0.287C7.47933 0.0956668 7.71667 0 8 0C8.28333 0 8.521 0.0956668 8.713 0.287C8.90433 0.479 9 0.716667 9 1V8.15L10.875 6.275C11.0583 6.09167 11.296 6.004 11.588 6.012C11.8793 6.02067 12.1167 6.11667 12.3 6.3C12.4833 6.48333 12.575 6.71667 12.575 7C12.575 7.28333 12.4833 7.51667 12.3 7.7L8.7 11.3C8.6 11.4 8.49167 11.4707 8.375 11.512C8.25833 11.554 8.13333 11.575 8 11.575ZM2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V12C0 11.7167 0.0956668 11.479 0.287 11.287C0.479 11.0957 0.716667 11 1 11C1.28333 11 1.521 11.0957 1.713 11.287C1.90433 11.479 2 11.7167 2 12V14H14V12C14 11.7167 14.096 11.479 14.288 11.287C14.4793 11.0957 14.7167 11 15 11C15.2833 11 15.5207 11.0957 15.712 11.287C15.904 11.479 16 11.7167 16 12V14C16 14.55 15.8043 15.021 15.413 15.413C15.021 15.8043 14.55 16 14 16H2Z"
      fill="black"
    />
  </Icon>
);

export const MetricIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 38 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34 0H3.77778C1.7 0 0 1.7 0 3.77778V30.2222C0 32.3 1.7 34 3.77778 34H34C36.0778 34 37.7778 32.3 37.7778 30.2222V3.77778C37.7778 1.7 36.0778 0 34 0ZM15.1111 26.4444H5.66667V22.6667H15.1111V26.4444ZM15.1111 18.8889H5.66667V15.1111H15.1111V18.8889ZM15.1111 11.3333H5.66667V7.55556H15.1111V11.3333ZM24.2156 22.6667L18.8889 17.3022L21.5522 14.6389L24.2156 17.3211L30.2033 11.3333L32.8856 14.0156L24.2156 22.6667Z"
      fill="black"
    />
  </Icon>
);

export const DocIcon = (props) => (
  <Icon
    {...props}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3 24.8966H18.7V18.2575H25.5V14.9379H18.7V8.29886H15.3V14.9379H8.5V18.2575H15.3V24.8966ZM17 33.1954C14.6483 33.1954 12.4383 32.7595 10.37 31.8875C8.30167 31.0167 6.5025 29.8344 4.9725 28.3406C3.4425 26.8468 2.23153 25.0902 1.3396 23.0708C0.446534 21.0514 0 18.8937 0 16.5977C0 14.3017 0.446534 12.144 1.3396 10.1246C2.23153 8.10522 3.4425 6.34863 4.9725 4.85483C6.5025 3.36104 8.30167 2.17817 10.37 1.30624C12.4383 0.435413 14.6483 0 17 0C19.3517 0 21.5617 0.435413 23.63 1.30624C25.6983 2.17817 27.4975 3.36104 29.0275 4.85483C30.5575 6.34863 31.7685 8.10522 32.6604 10.1246C33.5535 12.144 34 14.3017 34 16.5977C34 18.8937 33.5535 21.0514 32.6604 23.0708C31.7685 25.0902 30.5575 26.8468 29.0275 28.3406C27.4975 29.8344 25.6983 31.0167 23.63 31.8875C21.5617 32.7595 19.3517 33.1954 17 33.1954ZM17 29.8759C20.7967 29.8759 24.0125 28.5896 26.6475 26.0169C29.2825 23.4443 30.6 20.3045 30.6 16.5977C30.6 12.8909 29.2825 9.75116 26.6475 7.17851C24.0125 4.60587 20.7967 3.31954 17 3.31954C13.2033 3.31954 9.9875 4.60587 7.3525 7.17851C4.7175 9.75116 3.4 12.8909 3.4 16.5977C3.4 20.3045 4.7175 23.4443 7.3525 26.0169C9.9875 28.5896 13.2033 29.8759 17 29.8759Z"
      fill="white"
    />
  </Icon>
);

export const DocLargeIcon = (props) => (
  <Icon
    {...props}
    width="90"
    height="88"
    viewBox="0 0 90 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.5 66H49.5V48.4H67.5V39.6H49.5V22H40.5V39.6H22.5V48.4H40.5V66ZM45 88C38.775 88 32.925 86.8443 27.45 84.5328C21.975 82.2243 17.2125 79.09 13.1625 75.13C9.1125 71.17 5.907 66.5133 3.546 61.16C1.182 55.8067 0 50.0867 0 44C0 37.9133 1.182 32.1933 3.546 26.84C5.907 21.4867 9.1125 16.83 13.1625 12.87C17.2125 8.91 21.975 5.77427 27.45 3.4628C32.925 1.15427 38.775 0 45 0C51.225 0 57.075 1.15427 62.55 3.4628C68.025 5.77427 72.7875 8.91 76.8375 12.87C80.8875 16.83 84.093 21.4867 86.454 26.84C88.818 32.1933 90 37.9133 90 44C90 50.0867 88.818 55.8067 86.454 61.16C84.093 66.5133 80.8875 71.17 76.8375 75.13C72.7875 79.09 68.025 82.2243 62.55 84.5328C57.075 86.8443 51.225 88 45 88ZM45 79.2C55.05 79.2 63.5625 75.79 70.5375 68.97C77.5125 62.15 81 53.8267 81 44C81 34.1733 77.5125 25.85 70.5375 19.03C63.5625 12.21 55.05 8.8 45 8.8C34.95 8.8 26.4375 12.21 19.4625 19.03C12.4875 25.85 9 34.1733 9 44C9 53.8267 12.4875 62.15 19.4625 68.97C26.4375 75.79 34.95 79.2 45 79.2Z"
      fill="#D4EEFF"
    />
  </Icon>
);

export const RightArrow = (props) => (
  <Icon
    {...props}
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.292444 0.293762C0.199741 0.386276 0.126193 0.496165 0.0760117 0.617138C0.0258302 0.738111 0 0.867794 0 0.998762C0 1.12973 0.0258302 1.25941 0.0760117 1.38039C0.126193 1.50136 0.199741 1.61125 0.292444 1.70376L4.17244 5.58376L0.292444 9.46376C0.105467 9.65074 0.000423431 9.90434 0.000423431 10.1688C0.000423431 10.4332 0.105467 10.6868 0.292444 10.8738C0.479422 11.0607 0.733018 11.1658 0.997444 11.1658C1.26187 11.1658 1.51547 11.0607 1.70244 10.8738L6.29244 6.28376C6.38515 6.19125 6.4587 6.08136 6.50888 5.96039C6.55906 5.83941 6.58489 5.70973 6.58489 5.57876C6.58489 5.44779 6.55906 5.31811 6.50888 5.19714C6.4587 5.07616 6.38515 4.96628 6.29244 4.87376L1.70244 0.283762C1.32244 -0.0962379 0.682444 -0.0962377 0.292444 0.293762Z"
      fill="#141D43"
    />
  </Icon>
);

export const AddButton = (props) => (
  <Icon
    {...props}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8 33H24.2V24.2H33V19.8H24.2V11H19.8V19.8H11V24.2H19.8V33ZM22 44C18.9567 44 16.0967 43.4221 13.42 42.2664C10.7433 41.1121 8.415 39.545 6.435 37.565C4.455 35.585 2.88787 33.2567 1.7336 30.58C0.577867 27.9033 0 25.0433 0 22C0 18.9567 0.577867 16.0967 1.7336 13.42C2.88787 10.7433 4.455 8.415 6.435 6.435C8.415 4.455 10.7433 2.88713 13.42 1.7314C16.0967 0.577133 18.9567 0 22 0C25.0433 0 27.9033 0.577133 30.58 1.7314C33.2567 2.88713 35.585 4.455 37.565 6.435C39.545 8.415 41.1121 10.7433 42.2664 13.42C43.4221 16.0967 44 18.9567 44 22C44 25.0433 43.4221 27.9033 42.2664 30.58C41.1121 33.2567 39.545 35.585 37.565 37.565C35.585 39.545 33.2567 41.1121 30.58 42.2664C27.9033 43.4221 25.0433 44 22 44ZM22 39.6C26.9133 39.6 31.075 37.895 34.485 34.485C37.895 31.075 39.6 26.9133 39.6 22C39.6 17.0867 37.895 12.925 34.485 9.515C31.075 6.105 26.9133 4.4 22 4.4C17.0867 4.4 12.925 6.105 9.515 9.515C6.105 12.925 4.4 17.0867 4.4 22C4.4 26.9133 6.105 31.075 9.515 34.485C12.925 37.895 17.0867 39.6 22 39.6Z"
      fill="#B8DEF8"
    />
  </Icon>
);

export const ShipmentButton = (props) => {
  <Icon
    {...props}
    viewBox="0 0 29 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.239 3.85714H17.2093C17.4263 3.85714 17.6399 3.9126 17.8297 4.01831C18.0196 4.12402 18.1796 4.27651 18.2946 4.46143L22.7179 11.5714H28.3596C28.4707 11.5713 28.58 11.6003 28.6765 11.6555C28.7731 11.7107 28.8537 11.7903 28.9104 11.8863C28.9671 11.9823 28.998 12.0915 28.9999 12.2031C29.0018 12.3147 28.9748 12.4249 28.9215 12.5229L23.8531 21.8571H23.0378C22.3748 21.8577 21.7144 21.7721 21.0732 21.6026L25.1241 14.1428H3.07171L4.41303 21.6308C3.8067 21.7815 3.18437 21.8575 2.55976 21.8571H1.86223L0.275174 13.0873C0.241651 12.9022 0.248972 12.712 0.296622 12.53C0.344272 12.3481 0.431089 12.1788 0.550947 12.0343C0.670805 11.8897 0.820783 11.7734 0.990299 11.6934C1.15981 11.6134 1.34474 11.5718 1.53202 11.5714H2.55976V5.14285C2.55976 4.80186 2.6946 4.47484 2.93463 4.23372C3.17465 3.9926 3.5002 3.85714 3.83964 3.85714H5.11952V0H10.239V3.85714ZM5.11952 11.5714H19.6999L16.5002 6.42857H5.11952V11.5714ZM2.55976 24.4286C4.4492 24.4312 6.27279 23.7314 7.67928 22.464C9.08578 23.7314 10.9094 24.4312 12.7988 24.4286C14.6882 24.4312 16.5118 23.7314 17.9183 22.464C19.3248 23.7314 21.1484 24.4312 23.0378 24.4286H25.5976V27H23.0378C21.2404 27.0029 19.4742 26.5283 17.9183 25.6243C16.3624 26.5283 14.5962 27.0029 12.7988 27C11.0014 27.0029 9.23517 26.5283 7.67928 25.6243C6.12339 26.5283 4.35717 27.0029 2.55976 27H0V24.4286H2.55976Z"
      fill="#141D43"
    />
  </Icon>;
};

export const StockIcon = (props) => (
  <Icon
    {...props}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="5" fill="#141D43" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.9375 23.4615H4.0625V24.2308C4.0625 24.6557 3.7128 25 3.28125 25C2.8497 25 2.5 24.6557 2.5 24.2308V5.76923C2.5 5.34432 2.8497 5 3.28125 5C3.7128 5 4.0625 5.34432 4.0625 5.76923V12.1798H25.9375V5.76923C25.9375 5.34432 26.2872 5 26.7188 5C27.1503 5 27.5 5.34432 27.5 5.76923V24.2308C27.5 24.6557 27.1503 25 26.7188 25C26.2872 25 25.9375 24.6557 25.9375 24.2308V23.4615ZM25.9375 21.9231V13.7179H4.0625V21.9231H25.9375ZM19.6875 9.61538H23.3333V6.53846H19.6875V9.61538ZM24.8958 5.51282V10.641C24.8958 10.9242 24.6626 11.1538 24.375 11.1538H18.6458C18.3582 11.1538 18.125 10.9242 18.125 10.641V5.51282C18.125 5.22963 18.3582 5 18.6458 5H24.375C24.6626 5 24.8958 5.22963 24.8958 5.51282ZM6.66667 19.359H10.3125V16.2821H6.66667V19.359ZM11.875 15.2564V20.3846C11.875 20.6678 11.6418 20.8974 11.3542 20.8974H5.625C5.33738 20.8974 5.10417 20.6678 5.10417 20.3846V15.2564C5.10417 14.9732 5.33738 14.7436 5.625 14.7436H11.3542C11.6418 14.7436 11.875 14.9732 11.875 15.2564ZM14.4792 19.359H18.125V16.2821H14.4792V19.359ZM19.6875 15.2564V20.3846C19.6875 20.6678 19.4543 20.8974 19.1667 20.8974H13.4375C13.1499 20.8974 12.9167 20.6678 12.9167 20.3846V15.2564C12.9167 14.9732 13.1499 14.7436 13.4375 14.7436H19.1667C19.4543 14.7436 19.6875 14.9732 19.6875 15.2564Z"
      fill="white"
    />
  </Icon>
);
export const UploadIcon = (props) => {
  <Icon
    {...props}
    width="16"
    height="17"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V12C0 11.4477 0.447715 11 1 11C1.55228 11 2 11.4477 2 12V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12V14C16 14.55 15.8043 15.021 15.413 15.413C15.021 15.8043 14.55 16 14 16H2ZM8 12C7.44772 12 7 11.5523 7 11V3.85L5.12511 5.72489C4.72672 6.12328 4.07906 6.1176 3.68772 5.71228C3.30597 5.31689 3.31148 4.68852 3.70011 4.29989L6.58578 1.41421C7.36683 0.633166 8.63316 0.633165 9.41421 1.41421L12.2999 4.29989C12.6885 4.68852 12.694 5.31689 12.3123 5.71228C11.9209 6.1176 11.2733 6.12328 10.8749 5.72489L9 3.85V11C9 11.5523 8.55228 12 8 12Z"
      fill="black"
    />
  </Icon>;
};
export const IncomingIcon = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.3089 51.2697H18.4716C17.2011 51.2697 16.5071 52.7614 17.3223 53.7438L26.2145 64.4586C26.4996 64.8019 26.921 65 27.3656 65H59.83C62.6862 65 65 62.6703 65 59.7981V51.2705L64.9991 26.9729C64.9991 26.626 64.8459 26.2952 64.5813 26.0729L53.2676 16.5654C52.5085 15.928 51.3565 16.4704 51.3565 17.4654V41.9673L10.5742 0.931161C9.34028 -0.310387 7.33918 -0.310387 6.10346 0.931161L0.925453 6.14111C-0.308484 7.38266 -0.308484 9.39609 0.925453 10.6394L41.3089 51.2697Z"
      fill="black"
    />
  </Icon>
);

export const IncomingIconSmall = (props) => (
  <Icon
    {...props}
    width="35"
    height="35"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.3089 51.2697H18.4716C17.2011 51.2697 16.5071 52.7614 17.3223 53.7438L26.2145 64.4586C26.4996 64.8019 26.921 65 27.3656 65H59.83C62.6862 65 65 62.6703 65 59.7981V51.2705L64.9991 26.9729C64.9991 26.626 64.8459 26.2952 64.5813 26.0729L53.2676 16.5654C52.5085 15.928 51.3565 16.4704 51.3565 17.4654V41.9673L10.5742 0.931161C9.34028 -0.310387 7.33918 -0.310387 6.10346 0.931161L0.925453 6.14111C-0.308484 7.38266 -0.308484 9.39609 0.925453 10.6394L41.3089 51.2697Z"
      fill="black"
    />
  </Icon>
);
export const IncomingIcon2 = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.3089 51.2697H18.4716C17.2011 51.2697 16.5071 52.7614 17.3223 53.7438L26.2145 64.4586C26.4996 64.8019 26.921 65 27.3656 65H59.83C62.6862 65 65 62.6703 65 59.7981V51.2705L64.9991 26.9729C64.9991 26.626 64.8459 26.2952 64.5813 26.0729L53.2676 16.5654C52.5085 15.928 51.3565 16.4704 51.3565 17.4654V41.9673L10.5742 0.931161C9.34028 -0.310387 7.33918 -0.310387 6.10346 0.931161L0.925453 6.14111C-0.308484 7.38266 -0.308484 9.39609 0.925453 10.6394L41.3089 51.2697Z"
      fill="white"
    />
  </Icon>
);
export const AssignedIcon = (props) => (
  <Icon
    {...props}
    width="87"
    height="101"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.4945 18.9999C26.5573 18.9999 26.6201 18.9992 26.683 18.9976C31.9204 18.8965 36.0992 14.5539 35.9982 9.31583C35.9492 6.77905 34.9152 4.41325 33.0868 2.65332C31.2586 0.894024 28.8414 -0.0358063 26.3169 0.00105514C23.78 0.050073 21.4134 1.08404 19.6542 2.91233C17.8948 4.7413 16.9528 7.14551 17.0018 9.68209C17.0508 12.2187 18.0841 14.5854 19.9132 16.3446C21.6963 18.0618 24.0269 19 26.4947 19L26.4945 18.9999ZM22.8189 5.95805C23.7648 4.97463 25.0369 4.41857 26.4012 4.39253C26.4349 4.39177 26.4686 4.39177 26.5023 4.39177C27.8297 4.39177 29.0827 4.89649 30.0417 5.81864C31.0251 6.76453 31.5812 8.03738 31.6073 9.40087C31.6616 12.217 29.4143 14.5523 26.5989 14.6068C23.7679 14.6259 21.4473 12.4131 21.3936 9.59772C21.3668 8.23442 21.873 6.94154 22.819 5.95824L22.8189 5.95805Z"
      fill="#141D43"
    />
    <path
      d="M84.7564 56.3311H64.9179C63.6792 56.3311 62.6744 57.3341 62.6744 58.5707V66.406L45.0786 66.4053C43.8399 66.4053 42.8351 67.4083 42.8351 68.6449V76.3716H34.8283C37.3598 75.6045 39.3685 73.4695 39.788 70.6931C39.788 70.6931 41.4375 59.923 41.6222 58.7481C42.5737 55.0382 40.3631 51.2205 36.6399 50.1926L26.6683 47.453L28.4673 39.5013L29.8038 40.8145C31.7054 42.6635 34.1655 42.6995 35.9623 42.726C36.9944 42.7409 38.0266 42.7846 39.0587 42.8276L43.9276 43.0119C43.9988 43.0143 44.0693 43.0151 44.1405 43.0151C45.7595 43.0151 47.2924 42.4128 48.4779 41.3058C49.7151 40.1497 50.4272 38.5795 50.482 36.8968C50.5454 35.2048 49.9405 33.5909 48.7792 32.3518C47.6235 31.1191 46.0568 30.4058 44.3556 30.3425L37.0047 30.1019L31.4644 24.6556C30.7296 23.933 30.0348 23.2503 29.4393 22.5074C28.5152 21.352 27.1536 20.52 25.5839 20.1608C24.1855 19.8553 22.7519 19.9897 21.3934 20.5248C21.2158 20.5709 21.0405 20.624 20.83 20.6935L8.8395 24.9956C6.58743 25.8002 5.50988 27.4438 4.82276 28.7851C3.83756 30.7083 2.84454 32.6277 1.85232 34.547L0.711406 36.7554C-0.894328 39.8481 0.309193 43.683 3.40559 45.3101C4.33757 45.7921 5.33608 46.0202 6.32134 46.0202C8.61327 46.0202 10.8341 44.7836 11.9719 42.6259L14.2326 38.302L5.23898 78.0247C4.39464 81.797 6.76725 85.5601 10.5304 86.4458H5.40104C4.16231 86.4458 3.15759 87.4489 3.15759 88.6854V98.7604C3.15759 99.997 4.16235 101 5.40104 101C6.63974 101 7.64449 99.997 7.64449 98.7604V90.925H25.2395C26.4783 90.925 27.483 89.922 27.483 88.6854V80.8517H44.423C44.6311 80.9157 44.8479 80.9603 45.0779 80.9603C46.3167 80.9603 47.3214 79.9572 47.3214 78.7207L47.3222 70.8853H64.918C66.1568 70.8853 67.1615 69.8823 67.1615 68.6457V60.8103H84.7565C85.9953 60.8103 87 59.8073 87 58.5707C87 57.3333 85.996 56.3311 84.7565 56.3311L84.7564 56.3311ZM35.4461 54.5117C36.8257 54.8921 37.6403 56.317 37.2749 57.6404C37.2193 57.8232 37.2193 57.8232 35.3514 70.0198C35.1386 71.4283 33.813 72.4064 32.4106 72.1906C31.1586 71.9984 30.2329 70.9485 30.2078 69.6978C30.2055 69.533 30.2258 69.3744 30.2423 69.2471L31.5147 60.8432C31.5194 60.8119 31.5162 60.7807 31.5194 60.7494C31.528 60.6713 31.5303 60.5948 31.5311 60.5174C31.5311 60.4448 31.5303 60.3737 31.524 60.3026C31.517 60.2292 31.5053 60.1573 31.4912 60.0854C31.4771 60.0136 31.4622 59.9425 31.4419 59.8729C31.4215 59.805 31.3965 59.7401 31.3699 59.6753C31.3425 59.6073 31.3143 59.5402 31.2799 59.4753C31.247 59.4128 31.2095 59.3535 31.1711 59.2941C31.132 59.2339 31.0929 59.1746 31.0475 59.1191C31.0021 59.0621 30.9536 59.0105 30.9027 58.9582C30.8534 58.9066 30.8033 58.8566 30.7486 58.8105C30.6938 58.7637 30.6351 58.7215 30.5756 58.6801C30.5154 58.6379 30.4543 58.5973 30.3894 58.5613C30.3268 58.5262 30.2618 58.4965 30.1945 58.4676C30.1241 58.4371 30.0545 58.4082 29.9801 58.3848C29.9496 58.3746 29.9222 58.359 29.8909 58.3504L24.5346 56.8787L25.6771 51.8291L35.4461 54.5117ZM7.99541 40.5464C7.51651 41.4526 6.38262 41.8049 5.48111 41.3393C4.57259 40.862 4.21968 39.7301 4.69623 38.8122L5.83793 36.6013C6.83251 34.6773 7.82711 32.7533 8.81538 30.8252C9.37333 29.7362 9.80059 29.4089 10.3515 29.2121L16.8112 26.8943L15.8393 31.1861L13.0301 32.1938C12.9824 32.211 12.9425 32.2376 12.8963 32.2571C12.8196 32.2907 12.7429 32.3235 12.6694 32.3649C12.6091 32.4001 12.5544 32.4407 12.498 32.4805C12.4354 32.5243 12.3736 32.5672 12.3157 32.618C12.2593 32.6672 12.21 32.7211 12.1592 32.775C12.1107 32.8266 12.0614 32.8766 12.0175 32.9328C11.9659 32.9992 11.9229 33.0711 11.879 33.143C11.8532 33.1852 11.8219 33.2211 11.7984 33.2649L7.99541 40.5464ZM9.61681 79.0052L21.5034 26.4956C21.6833 25.7066 22.2076 25.0582 22.9135 24.7247C22.9299 24.7176 22.9479 24.7114 22.9643 24.7036C23.4957 24.4739 24.0654 24.413 24.5998 24.5317C25.1484 24.6575 25.6461 24.9465 25.9325 25.3035C26.6946 26.2558 27.5179 27.0651 28.3145 27.8479L34.48 33.9092C34.5168 33.9451 34.5598 33.9709 34.5981 34.0045C34.6607 34.0584 34.7218 34.1115 34.7899 34.1584C34.8478 34.1982 34.9088 34.2303 34.9691 34.2631C35.0356 34.2998 35.1013 34.3373 35.1717 34.3678C35.239 34.3967 35.3079 34.417 35.3767 34.4389C35.4464 34.4607 35.5152 34.4842 35.588 34.4998C35.6655 34.5162 35.7437 34.5232 35.8228 34.531C35.876 34.5365 35.9261 34.5506 35.9809 34.5521L44.1974 34.8209C44.6982 34.8396 45.1615 35.0505 45.5019 35.4146C45.8392 35.7747 46.0145 36.2418 45.9957 36.7426C45.9792 37.2402 45.7719 37.7003 45.4103 38.0378C45.0488 38.376 44.5785 38.5534 44.084 38.5378L39.2465 38.355C38.1736 38.3104 37.1008 38.2651 36.0288 38.2495C34.5812 38.2284 33.5123 38.1698 32.9434 37.6167L28.7412 33.4867C28.7044 33.45 28.6613 33.425 28.6222 33.3914C28.5588 33.3367 28.4962 33.282 28.4266 33.2344C28.3655 33.193 28.3022 33.1609 28.238 33.1258C28.1738 33.0906 28.1112 33.0539 28.0431 33.025C27.9657 32.9922 27.8859 32.9695 27.806 32.9461C27.7567 32.9313 27.7121 32.9094 27.6613 32.8977C27.648 32.8945 27.6347 32.8953 27.6214 32.893C27.5306 32.8742 27.439 32.868 27.3467 32.8602C27.2927 32.8563 27.2395 32.8461 27.1863 32.8461C27.0838 32.8453 26.9828 32.8578 26.8811 32.8711C26.8404 32.8766 26.7982 32.8766 26.7583 32.8836C26.6432 32.9047 26.5313 32.9398 26.4202 32.9789C26.3967 32.9875 26.3709 32.9914 26.3474 33.0008C26.2441 33.0414 26.1455 33.0953 26.0485 33.1515C26.0195 33.168 25.9882 33.1812 25.9601 33.1992C25.8842 33.2476 25.8145 33.307 25.7441 33.3656C25.6987 33.4031 25.651 33.4367 25.6087 33.4773C25.5962 33.4898 25.5806 33.4984 25.568 33.5109C25.5234 33.5562 25.4906 33.6085 25.4499 33.657C25.4053 33.7101 25.3591 33.7609 25.32 33.8187C25.273 33.8866 25.2362 33.9577 25.1979 34.0296C25.1666 34.0874 25.1337 34.1437 25.1071 34.2046C25.0727 34.2858 25.0484 34.3686 25.0242 34.4522C25.0101 34.4991 24.989 34.5413 24.978 34.5897L14.6714 80.1439C14.3545 81.5352 12.9647 82.4125 11.5812 82.0953C10.1883 81.7774 9.30709 80.39 9.61706 79.0066L9.61681 79.0052ZM25.2398 76.3719C24.0011 76.3719 22.9964 77.3749 22.9964 78.6115V86.4452H13.6866C16.2634 85.8648 18.4209 83.8774 19.047 81.1333L23.5449 61.2529L26.7792 62.1411L25.7987 68.6164C25.7556 68.9398 25.7118 69.332 25.7204 69.7811C25.7807 72.8685 27.8316 75.4869 30.7262 76.3712L25.2398 76.3719Z"
      fill="#141D43"
    />
  </Icon>
);
export const CompletedIcon = (props) => (
  <Icon
    {...props}
    width="87"
    height="101"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.244 48.7279C14.6992 50.0916 15.1078 51.4553 16.0611 52.5462C19.1935 55.6828 21.2364 57.8647 24.505 61.0012C24.9136 61.4103 25.4584 61.6831 25.8669 61.8194C27.365 62.2285 28.5908 61.9558 29.6803 60.8648C32.2679 58.2738 35.2641 55.41 38.8051 51.8644C41.6651 49.0006 45.0699 45.8641 47.7937 43.1367L48.0661 42.8639C49.1556 41.773 49.2918 39.8638 48.4747 38.6364C47.7937 37.5455 46.7042 37 45.4785 37C44.5251 37 43.5718 37.4091 42.8908 38.091C40.5756 40.4093 37.5794 43.273 35.4003 45.455L34.9917 45.8641C32.6765 48.1824 29.9527 50.7734 27.6374 53.0917L26.9565 53.3645L21.1002 47.3642C20.4193 46.6823 19.4659 46.2732 18.5126 46.2732H18.2402C16.7421 46.4096 15.6526 47.3642 15.244 48.7279Z"
      fill="#141D43"
    />
    <path
      d="M47.8657 12.3415C47.7307 11.939 47.4607 11.5366 47.3257 11.1341C46.7856 10.3293 45.8404 9.65854 44.8952 9.39024C44.4901 9.2561 44.0851 9.2561 43.815 9.2561H41.2496V8.85366C41.2496 4.02439 37.1988 0 32.2029 0H31.9329C29.3674 0 27.207 0.939024 25.4517 2.54878C23.8314 4.15854 22.7512 6.43902 22.7512 8.85366V9.2561H20.1858C19.7807 9.2561 19.3756 9.2561 19.1056 9.39024C18.1604 9.65854 17.2152 10.1951 16.6751 11.1341C16.4051 11.5366 16.27 11.939 16.135 12.3415C16 12.6098 16 12.878 16 13.1463V18.1098C16 18.378 16.135 18.6463 16.135 18.9146C16.6751 20.6585 18.2954 22 20.1858 22H43.8142C45.7046 21.8659 47.3249 20.6585 47.865 18.9146C48 18.6463 48 18.378 48 18.1098V13.0122C48 12.878 47.865 12.6098 47.865 12.3415H47.8657ZM36.7938 9.2561H27.072V8.85366C27.207 6.30488 29.2324 4.29268 31.7978 4.29268H32.0679C34.6334 4.29268 36.7938 6.30488 36.7938 8.85366V9.2561Z"
      fill="#141D43"
    />
    <path
      d="M63.9009 61.7V60.8962V55.0019V49.5094V47.0981V25.1283C63.9009 19.6358 61.6378 15.617 57.1115 13.2057C55.514 12.4019 53.7834 12 51.5203 12H50.3221V17.7604H50.5884C51.3871 17.7604 52.0528 17.7604 52.5853 17.8943C55.6471 18.0283 58.1765 20.7075 58.3097 23.6547C58.4428 26.6019 58.4428 29.5491 58.4428 32.2283V55.5377V69.0679C58.4428 70.6755 58.4428 72.283 57.644 73.7566C56.3128 76.1679 54.449 77.3736 51.9196 77.3736H11.8482C9.31877 77.3736 7.45502 76.1679 6.12376 73.7566C5.32501 72.283 5.32501 70.6755 5.32501 69.0679V55.5377V32.2283C5.32501 29.5491 5.32501 26.4679 5.45814 23.6547C5.59126 20.7075 8.12064 18.1623 11.1825 17.8943C11.715 17.8943 12.3807 17.8943 13.1794 17.7604H13.4457V12H12.2475C9.85127 12 8.12064 12.4019 6.65627 13.2057C2.26313 15.7509 0 19.7698 0 25.1283V47.0981V49.5094V55.0019V60.8962V61.7C0 67.3264 0 65.7189 0.133125 71.3453C0.266251 74.4264 1.46438 77.3736 3.72751 79.517C5.99064 81.7943 8.9194 83 11.9813 83H31.4176H32.6157H52.052C55.1139 83 58.0426 81.7943 60.3058 79.517C62.5689 77.3736 63.767 74.4264 63.9002 71.3453C64.0333 65.7189 64.0333 67.3264 63.9002 61.7H63.9009Z"
      fill="#141D43"
    />
  </Icon>
);
export const PendingIcon = (props) => (
  <Icon
    {...props}
    width="87"
    height="101"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6875 18.2508H18.0563C19.218 18.2738 20.347 17.8657 21.2255 17.1058C22.1039 16.3452 22.6688 15.2862 22.8128 14.1332C22.9385 12.8483 22.5144 11.5697 21.644 10.6156C20.7744 9.66083 19.5412 9.11978 18.2498 9.12615H13.6876C10.0572 9.12615 6.57618 10.5679 4.00934 13.1347C1.44189 15.7021 0 19.1831 0 22.8138V59.3142C0 62.9447 1.4417 66.4256 4.00934 68.9925C6.57618 71.5599 10.057 73.0018 13.6876 73.0018H50.188C53.8185 73.0018 57.2995 71.5601 59.8671 68.9925C62.434 66.4256 63.8757 62.9449 63.8757 59.3142V54.9453C63.8987 53.7837 63.4906 52.6547 62.7307 51.7762C61.9701 50.8978 60.9111 50.3329 59.7582 50.1889C58.4732 50.0632 57.1946 50.4872 56.2405 51.3577C55.2857 52.2273 54.7447 53.4605 54.7511 54.7519V59.314C54.7511 60.5242 54.2697 61.6843 53.4144 62.5404C52.5591 63.3957 51.3982 63.8763 50.188 63.8763H13.6876C12.4774 63.8763 11.3173 63.3957 10.4612 62.5404C9.60593 61.6843 9.12536 60.5243 9.12536 59.314V22.8137C9.12536 21.6035 9.60593 20.4426 10.4612 19.5873C11.3174 18.732 12.4774 18.2506 13.6876 18.2506L13.6875 18.2508Z"
      fill="#141D43"
    />
    <path
      d="M54.7505 0.000612274C52.3293 -0.00177471 50.0069 0.958563 48.2939 2.66929L23.2569 27.7063C20.0377 30.9096 18.2348 35.2673 18.2491 39.808V45.6257C18.2491 48.0461 19.2111 50.3669 20.9225 52.0776C22.6331 53.789 24.954 54.751 27.3744 54.751H33.1921C37.7328 54.7653 42.0907 52.9624 45.2938 49.7432L70.3308 24.7062C72.0414 22.9932 73.0017 20.6708 72.9995 18.2496C72.9995 13.4096 71.0772 8.76783 67.6544 5.34511C64.2314 1.92218 59.5897 0 54.7499 0L54.7505 0.000612274ZM38.8384 43.2878C37.341 44.7852 35.3098 45.6261 33.1925 45.6261H27.3748V39.8084C27.3748 37.6911 28.2158 35.66 29.7131 34.1625L54.7501 9.1255C57.1697 9.1255 59.4905 10.0867 61.202 11.7981C62.9136 13.5095 63.8746 15.8304 63.8746 18.25L38.8384 43.2878Z"
      fill="#141D43"
    />
  </Icon>
);

export const PendingIconSmall = (props) => (
  <Icon
    {...props}
    width="37"
    height="51"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6875 18.2508H18.0563C19.218 18.2738 20.347 17.8657 21.2255 17.1058C22.1039 16.3452 22.6688 15.2862 22.8128 14.1332C22.9385 12.8483 22.5144 11.5697 21.644 10.6156C20.7744 9.66083 19.5412 9.11978 18.2498 9.12615H13.6876C10.0572 9.12615 6.57618 10.5679 4.00934 13.1347C1.44189 15.7021 0 19.1831 0 22.8138V59.3142C0 62.9447 1.4417 66.4256 4.00934 68.9925C6.57618 71.5599 10.057 73.0018 13.6876 73.0018H50.188C53.8185 73.0018 57.2995 71.5601 59.8671 68.9925C62.434 66.4256 63.8757 62.9449 63.8757 59.3142V54.9453C63.8987 53.7837 63.4906 52.6547 62.7307 51.7762C61.9701 50.8978 60.9111 50.3329 59.7582 50.1889C58.4732 50.0632 57.1946 50.4872 56.2405 51.3577C55.2857 52.2273 54.7447 53.4605 54.7511 54.7519V59.314C54.7511 60.5242 54.2697 61.6843 53.4144 62.5404C52.5591 63.3957 51.3982 63.8763 50.188 63.8763H13.6876C12.4774 63.8763 11.3173 63.3957 10.4612 62.5404C9.60593 61.6843 9.12536 60.5243 9.12536 59.314V22.8137C9.12536 21.6035 9.60593 20.4426 10.4612 19.5873C11.3174 18.732 12.4774 18.2506 13.6876 18.2506L13.6875 18.2508Z"
      fill="#141D43"
    />
    <path
      d="M54.7505 0.000612274C52.3293 -0.00177471 50.0069 0.958563 48.2939 2.66929L23.2569 27.7063C20.0377 30.9096 18.2348 35.2673 18.2491 39.808V45.6257C18.2491 48.0461 19.2111 50.3669 20.9225 52.0776C22.6331 53.789 24.954 54.751 27.3744 54.751H33.1921C37.7328 54.7653 42.0907 52.9624 45.2938 49.7432L70.3308 24.7062C72.0414 22.9932 73.0017 20.6708 72.9995 18.2496C72.9995 13.4096 71.0772 8.76783 67.6544 5.34511C64.2314 1.92218 59.5897 0 54.7499 0L54.7505 0.000612274ZM38.8384 43.2878C37.341 44.7852 35.3098 45.6261 33.1925 45.6261H27.3748V39.8084C27.3748 37.6911 28.2158 35.66 29.7131 34.1625L54.7501 9.1255C57.1697 9.1255 59.4905 10.0867 61.202 11.7981C62.9136 13.5095 63.8746 15.8304 63.8746 18.25L38.8384 43.2878Z"
      fill="#141D43"
    />
  </Icon>
);

export const PendingMetricIcon = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6875 18.2508H18.0563C19.218 18.2738 20.347 17.8657 21.2255 17.1058C22.1039 16.3452 22.6688 15.2862 22.8128 14.1332C22.9385 12.8483 22.5144 11.5697 21.644 10.6156C20.7744 9.66083 19.5412 9.11978 18.2498 9.12615H13.6876C10.0572 9.12615 6.57618 10.5679 4.00934 13.1347C1.44189 15.7021 0 19.1831 0 22.8138V59.3142C0 62.9447 1.4417 66.4256 4.00934 68.9925C6.57618 71.5599 10.057 73.0018 13.6876 73.0018H50.188C53.8185 73.0018 57.2995 71.5601 59.8671 68.9925C62.434 66.4256 63.8757 62.9449 63.8757 59.3142V54.9453C63.8987 53.7837 63.4906 52.6547 62.7307 51.7762C61.9701 50.8978 60.9111 50.3329 59.7582 50.1889C58.4732 50.0632 57.1946 50.4872 56.2405 51.3577C55.2857 52.2273 54.7447 53.4605 54.7511 54.7519V59.314C54.7511 60.5242 54.2697 61.6843 53.4144 62.5404C52.5591 63.3957 51.3982 63.8763 50.188 63.8763H13.6876C12.4774 63.8763 11.3173 63.3957 10.4612 62.5404C9.60593 61.6843 9.12536 60.5243 9.12536 59.314V22.8137C9.12536 21.6035 9.60593 20.4426 10.4612 19.5873C11.3174 18.732 12.4774 18.2506 13.6876 18.2506L13.6875 18.2508Z"
      fill="#141D43"
    />
    <path
      d="M54.7505 0.000612274C52.3293 -0.00177471 50.0069 0.958563 48.2939 2.66929L23.2569 27.7063C20.0377 30.9096 18.2348 35.2673 18.2491 39.808V45.6257C18.2491 48.0461 19.2111 50.3669 20.9225 52.0776C22.6331 53.789 24.954 54.751 27.3744 54.751H33.1921C37.7328 54.7653 42.0907 52.9624 45.2938 49.7432L70.3308 24.7062C72.0414 22.9932 73.0017 20.6708 72.9995 18.2496C72.9995 13.4096 71.0772 8.76783 67.6544 5.34511C64.2314 1.92218 59.5897 0 54.7499 0L54.7505 0.000612274ZM38.8384 43.2878C37.341 44.7852 35.3098 45.6261 33.1925 45.6261H27.3748V39.8084C27.3748 37.6911 28.2158 35.66 29.7131 34.1625L54.7501 9.1255C57.1697 9.1255 59.4905 10.0867 61.202 11.7981C62.9136 13.5095 63.8746 15.8304 63.8746 18.25L38.8384 43.2878Z"
      fill="#141D43"
    />
  </Icon>
);

export const AcceptedIcon = (props) => (
  <Icon
    {...props}
    width="87"
    height="101"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.1793 16.9885C51.1793 26.3706 43.573 33.9769 34.1908 33.9769C24.8087 33.9769 17.2024 26.3706 17.2024 16.9885C17.2024 7.60565 24.8087 0 34.1908 0C43.573 0 51.1793 7.60565 51.1793 16.9885Z"
      fill="#141D43"
    />
    <path
      d="M64.3931 58.3642L59.9381 50.8136V50.8142C59.4982 49.8403 58.6665 49.0989 57.649 48.7735C56.6321 48.448 55.5241 48.5681 54.6008 49.1053C53.6768 49.6419 53.0239 50.545 52.804 51.5903C52.5835 52.6356 52.8167 53.7252 53.4449 54.5892L57.9373 62.1398C58.4227 62.8957 58.623 63.8008 58.5011 64.6907C58.3791 65.5812 57.9436 66.3991 57.2731 66.9969C56.6025 67.5948 55.7404 67.9342 54.8418 67.9538H34.1919C32.8432 67.9538 31.5969 68.673 30.9225 69.8409C30.2482 71.0089 30.2482 72.4486 30.9225 73.6166C31.5969 74.7846 32.8432 75.5037 34.1919 75.5037H54.8418C57.5051 75.4646 60.0697 74.4875 62.084 72.745C64.0989 71.002 65.4343 68.6053 65.8564 65.9748C66.2793 63.345 65.761 60.6502 64.3933 58.3642L64.3931 58.3642Z"
      fill="#141D43"
    />
    <path
      d="M8.06439 72.8479C8.76642 73.7257 9.83464 74.2288 10.9583 74.2112C12.0819 74.1936 13.1344 73.657 13.809 72.7585L30.1613 50.9551C31.3652 49.3496 31.0398 47.0719 29.4343 45.8675C27.8289 44.6635 25.5512 44.9884 24.3468 46.5945L10.8092 64.6445L6.47168 59.2229C5.21788 57.6553 2.93118 57.4016 1.364 58.6554C-0.203168 59.9091 -0.45733 62.1959 0.796424 63.7631L8.06439 72.8479Z"
      fill="#141D43"
    />
  </Icon>
);

export const AcceptedIconSmall = (props) => (
  <Icon
    {...props}
    width="37"
    height="51"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.1793 16.9885C51.1793 26.3706 43.573 33.9769 34.1908 33.9769C24.8087 33.9769 17.2024 26.3706 17.2024 16.9885C17.2024 7.60565 24.8087 0 34.1908 0C43.573 0 51.1793 7.60565 51.1793 16.9885Z"
      fill="#141D43"
    />
    <path
      d="M64.3931 58.3642L59.9381 50.8136V50.8142C59.4982 49.8403 58.6665 49.0989 57.649 48.7735C56.6321 48.448 55.5241 48.5681 54.6008 49.1053C53.6768 49.6419 53.0239 50.545 52.804 51.5903C52.5835 52.6356 52.8167 53.7252 53.4449 54.5892L57.9373 62.1398C58.4227 62.8957 58.623 63.8008 58.5011 64.6907C58.3791 65.5812 57.9436 66.3991 57.2731 66.9969C56.6025 67.5948 55.7404 67.9342 54.8418 67.9538H34.1919C32.8432 67.9538 31.5969 68.673 30.9225 69.8409C30.2482 71.0089 30.2482 72.4486 30.9225 73.6166C31.5969 74.7846 32.8432 75.5037 34.1919 75.5037H54.8418C57.5051 75.4646 60.0697 74.4875 62.084 72.745C64.0989 71.002 65.4343 68.6053 65.8564 65.9748C66.2793 63.345 65.761 60.6502 64.3933 58.3642L64.3931 58.3642Z"
      fill="#141D43"
    />
    <path
      d="M8.06439 72.8479C8.76642 73.7257 9.83464 74.2288 10.9583 74.2112C12.0819 74.1936 13.1344 73.657 13.809 72.7585L30.1613 50.9551C31.3652 49.3496 31.0398 47.0719 29.4343 45.8675C27.8289 44.6635 25.5512 44.9884 24.3468 46.5945L10.8092 64.6445L6.47168 59.2229C5.21788 57.6553 2.93118 57.4016 1.364 58.6554C-0.203168 59.9091 -0.45733 62.1959 0.796424 63.7631L8.06439 72.8479Z"
      fill="#141D43"
    />
  </Icon>
);

export const AcceptedMetricIcon = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.1793 16.9885C51.1793 26.3706 43.573 33.9769 34.1908 33.9769C24.8087 33.9769 17.2024 26.3706 17.2024 16.9885C17.2024 7.60565 24.8087 0 34.1908 0C43.573 0 51.1793 7.60565 51.1793 16.9885Z"
      fill="#141D43"
    />
    <path
      d="M64.3931 58.3642L59.9381 50.8136V50.8142C59.4982 49.8403 58.6665 49.0989 57.649 48.7735C56.6321 48.448 55.5241 48.5681 54.6008 49.1053C53.6768 49.6419 53.0239 50.545 52.804 51.5903C52.5835 52.6356 52.8167 53.7252 53.4449 54.5892L57.9373 62.1398C58.4227 62.8957 58.623 63.8008 58.5011 64.6907C58.3791 65.5812 57.9436 66.3991 57.2731 66.9969C56.6025 67.5948 55.7404 67.9342 54.8418 67.9538H34.1919C32.8432 67.9538 31.5969 68.673 30.9225 69.8409C30.2482 71.0089 30.2482 72.4486 30.9225 73.6166C31.5969 74.7846 32.8432 75.5037 34.1919 75.5037H54.8418C57.5051 75.4646 60.0697 74.4875 62.084 72.745C64.0989 71.002 65.4343 68.6053 65.8564 65.9748C66.2793 63.345 65.761 60.6502 64.3933 58.3642L64.3931 58.3642Z"
      fill="#141D43"
    />
    <path
      d="M8.06439 72.8479C8.76642 73.7257 9.83464 74.2288 10.9583 74.2112C12.0819 74.1936 13.1344 73.657 13.809 72.7585L30.1613 50.9551C31.3652 49.3496 31.0398 47.0719 29.4343 45.8675C27.8289 44.6635 25.5512 44.9884 24.3468 46.5945L10.8092 64.6445L6.47168 59.2229C5.21788 57.6553 2.93118 57.4016 1.364 58.6554C-0.203168 59.9091 -0.45733 62.1959 0.796424 63.7631L8.06439 72.8479Z"
      fill="#141D43"
    />
  </Icon>
);

export const RejectedIcon = (props) => (
  <Icon
    {...props}
    width="87"
    height="101"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.9314 16.4202C52.9314 25.4885 45.5795 32.8404 36.5112 32.8404C27.4428 32.8404 20.0909 25.4885 20.0909 16.4202C20.0909 7.35125 27.4428 0 36.5112 0C45.5795 0 52.9314 7.35125 52.9314 16.4202Z"
      fill="#141D43"
    />
    <path
      d="M65.7032 56.412L61.3972 49.114V49.1146C60.972 48.1732 60.1681 47.4566 59.1846 47.1421C58.2017 46.8275 57.1309 46.9436 56.2384 47.4628C55.3453 47.9814 54.7143 48.8544 54.5018 49.8647C54.2886 50.8751 54.514 51.9282 55.1212 52.7633L59.4633 60.0613C59.9325 60.7919 60.1261 61.6668 60.0082 62.5269C59.8903 63.3876 59.4694 64.1781 58.8213 64.756C58.1732 65.3338 57.3399 65.6619 56.4713 65.6808H36.5122C35.2086 65.6808 34.0039 66.376 33.3521 67.5049C32.7003 68.6338 32.7003 70.0253 33.3521 71.1542C34.0039 72.2832 35.2086 72.9783 36.5122 72.9783H56.4713C59.0455 72.9404 61.5244 71.996 63.4713 70.3118C65.4188 68.6271 66.7096 66.3106 67.1176 63.7681C67.5262 61.2263 67.0253 58.6215 65.7034 56.412L65.7032 56.412Z"
      fill="#141D43"
    />
    <path
      d="M24.5057 48.4944C23.8203 47.8035 22.8874 47.415 21.915 47.415C20.9419 47.415 20.009 47.8035 19.3244 48.4944L12.7923 55.0625L6.26076 48.4944C5.33529 47.5689 3.98586 47.2073 2.72197 47.5463C1.45747 47.8853 0.469743 48.8725 0.13133 50.1369C-0.207708 51.4014 0.153932 52.7503 1.0794 53.6757L7.64749 60.2072L1.0794 66.7387V66.7393C0.388502 67.4247 0 68.357 0 69.33C0 70.303 0.388518 71.2353 1.0794 71.9206C1.7648 72.6115 2.69703 73 3.67004 73C4.64306 73 5.57541 72.6115 6.26068 71.9206L12.7922 65.3525L19.3237 71.9206H19.3243C20.0091 72.6115 20.9419 73 21.9149 73C22.8874 73 23.8203 72.6115 24.5056 71.9206C25.1965 71.2352 25.585 70.303 25.585 69.33C25.585 68.357 25.1964 67.4246 24.5056 66.7393L17.9375 60.2078L24.5056 53.6763V53.6757C25.1965 52.991 25.585 52.0581 25.585 51.0851C25.585 50.1126 25.1964 49.1797 24.5056 48.4945L24.5057 48.4944Z"
      fill="#141D43"
    />
  </Icon>
);

export const RejectedIconSmall = (props) => (
  <Icon
    {...props}
    width="37"
    height="51"
    viewBox="0 0 87 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.9314 16.4202C52.9314 25.4885 45.5795 32.8404 36.5112 32.8404C27.4428 32.8404 20.0909 25.4885 20.0909 16.4202C20.0909 7.35125 27.4428 0 36.5112 0C45.5795 0 52.9314 7.35125 52.9314 16.4202Z"
      fill="#141D43"
    />
    <path
      d="M65.7032 56.412L61.3972 49.114V49.1146C60.972 48.1732 60.1681 47.4566 59.1846 47.1421C58.2017 46.8275 57.1309 46.9436 56.2384 47.4628C55.3453 47.9814 54.7143 48.8544 54.5018 49.8647C54.2886 50.8751 54.514 51.9282 55.1212 52.7633L59.4633 60.0613C59.9325 60.7919 60.1261 61.6668 60.0082 62.5269C59.8903 63.3876 59.4694 64.1781 58.8213 64.756C58.1732 65.3338 57.3399 65.6619 56.4713 65.6808H36.5122C35.2086 65.6808 34.0039 66.376 33.3521 67.5049C32.7003 68.6338 32.7003 70.0253 33.3521 71.1542C34.0039 72.2832 35.2086 72.9783 36.5122 72.9783H56.4713C59.0455 72.9404 61.5244 71.996 63.4713 70.3118C65.4188 68.6271 66.7096 66.3106 67.1176 63.7681C67.5262 61.2263 67.0253 58.6215 65.7034 56.412L65.7032 56.412Z"
      fill="#141D43"
    />
    <path
      d="M24.5057 48.4944C23.8203 47.8035 22.8874 47.415 21.915 47.415C20.9419 47.415 20.009 47.8035 19.3244 48.4944L12.7923 55.0625L6.26076 48.4944C5.33529 47.5689 3.98586 47.2073 2.72197 47.5463C1.45747 47.8853 0.469743 48.8725 0.13133 50.1369C-0.207708 51.4014 0.153932 52.7503 1.0794 53.6757L7.64749 60.2072L1.0794 66.7387V66.7393C0.388502 67.4247 0 68.357 0 69.33C0 70.303 0.388518 71.2353 1.0794 71.9206C1.7648 72.6115 2.69703 73 3.67004 73C4.64306 73 5.57541 72.6115 6.26068 71.9206L12.7922 65.3525L19.3237 71.9206H19.3243C20.0091 72.6115 20.9419 73 21.9149 73C22.8874 73 23.8203 72.6115 24.5056 71.9206C25.1965 71.2352 25.585 70.303 25.585 69.33C25.585 68.357 25.1964 67.4246 24.5056 66.7393L17.9375 60.2078L24.5056 53.6763V53.6757C25.1965 52.991 25.585 52.0581 25.585 51.0851C25.585 50.1126 25.1964 49.1797 24.5056 48.4945L24.5057 48.4944Z"
      fill="#141D43"
    />
  </Icon>
);

export const RejectedMetricIcon = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.9314 16.4202C52.9314 25.4885 45.5795 32.8404 36.5112 32.8404C27.4428 32.8404 20.0909 25.4885 20.0909 16.4202C20.0909 7.35125 27.4428 0 36.5112 0C45.5795 0 52.9314 7.35125 52.9314 16.4202Z"
      fill="#141D43"
    />
    <path
      d="M65.7032 56.412L61.3972 49.114V49.1146C60.972 48.1732 60.1681 47.4566 59.1846 47.1421C58.2017 46.8275 57.1309 46.9436 56.2384 47.4628C55.3453 47.9814 54.7143 48.8544 54.5018 49.8647C54.2886 50.8751 54.514 51.9282 55.1212 52.7633L59.4633 60.0613C59.9325 60.7919 60.1261 61.6668 60.0082 62.5269C59.8903 63.3876 59.4694 64.1781 58.8213 64.756C58.1732 65.3338 57.3399 65.6619 56.4713 65.6808H36.5122C35.2086 65.6808 34.0039 66.376 33.3521 67.5049C32.7003 68.6338 32.7003 70.0253 33.3521 71.1542C34.0039 72.2832 35.2086 72.9783 36.5122 72.9783H56.4713C59.0455 72.9404 61.5244 71.996 63.4713 70.3118C65.4188 68.6271 66.7096 66.3106 67.1176 63.7681C67.5262 61.2263 67.0253 58.6215 65.7034 56.412L65.7032 56.412Z"
      fill="#141D43"
    />
    <path
      d="M24.5057 48.4944C23.8203 47.8035 22.8874 47.415 21.915 47.415C20.9419 47.415 20.009 47.8035 19.3244 48.4944L12.7923 55.0625L6.26076 48.4944C5.33529 47.5689 3.98586 47.2073 2.72197 47.5463C1.45747 47.8853 0.469743 48.8725 0.13133 50.1369C-0.207708 51.4014 0.153932 52.7503 1.0794 53.6757L7.64749 60.2072L1.0794 66.7387V66.7393C0.388502 67.4247 0 68.357 0 69.33C0 70.303 0.388518 71.2353 1.0794 71.9206C1.7648 72.6115 2.69703 73 3.67004 73C4.64306 73 5.57541 72.6115 6.26068 71.9206L12.7922 65.3525L19.3237 71.9206H19.3243C20.0091 72.6115 20.9419 73 21.9149 73C22.8874 73 23.8203 72.6115 24.5056 71.9206C25.1965 71.2352 25.585 70.303 25.585 69.33C25.585 68.357 25.1964 67.4246 24.5056 66.7393L17.9375 60.2078L24.5056 53.6763V53.6757C25.1965 52.991 25.585 52.0581 25.585 51.0851C25.585 50.1126 25.1964 49.1797 24.5056 48.4945L24.5057 48.4944Z"
      fill="#141D43"
    />
  </Icon>
);

export const FileIcon = (props) => (
  <Icon
    {...props}
    width="50"
    height="10"
    viewBox="0 0 36 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33342 41.1666C3.32508 41.1666 2.46219 40.8079 1.74475 40.0904C1.02608 39.3718 0.666748 38.5083 0.666748 37.4999V11.8333H4.33342V37.4999H24.5001V41.1666H4.33342ZM11.6667 33.8333C10.6584 33.8333 9.79553 33.4745 9.07808 32.7571C8.35942 32.0384 8.00008 31.1749 8.00008 30.1666V4.49992C8.00008 3.49159 8.35942 2.62809 9.07808 1.90942C9.79553 1.19197 10.6584 0.833252 11.6667 0.833252H24.5001L35.5001 11.8333V30.1666C35.5001 31.1749 35.1414 32.0384 34.4239 32.7571C33.7052 33.4745 32.8418 33.8333 31.8334 33.8333H11.6667ZM22.6667 13.6666H31.8334L22.6667 4.49992V13.6666Z"
      fill="black"
    />
  </Icon>
);
export const RemoveIcon = (props) => (
  <Icon
    {...props}
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0C4.023 0 0 4.2465 0 9.5C0 14.7535 4.023 19 9 19C13.977 19 18 14.7535 18 9.5C18 4.2465 13.977 0 9 0ZM13.5 12.9105L12.231 14.25L9 10.8395L5.769 14.25L4.5 12.9105L7.731 9.5L4.5 6.0895L5.769 4.75L9 8.1605L12.231 4.75L13.5 6.0895L10.269 9.5L13.5 12.9105Z"
      fill="#D13434"
    />
  </Icon>
);
export const EyeIcon = (props) => (
  <Icon
    {...props}
    width="25"
    height="17"
    viewBox="0 0 65 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.5 0.9375C18.125 0.9375 5.84875 9.87875 0.875 22.5C5.84875 35.1212 18.125 44.0625 32.5 44.0625C46.875 44.0625 59.1512 35.1212 64.125 22.5C59.1512 9.87875 46.875 0.9375 32.5 0.9375ZM32.5 36.875C24.565 36.875 18.125 30.435 18.125 22.5C18.125 14.565 24.565 8.125 32.5 8.125C40.435 8.125 46.875 14.565 46.875 22.5C46.875 30.435 40.435 36.875 32.5 36.875ZM32.5 13.875C27.7275 13.875 23.875 17.7275 23.875 22.5C23.875 27.2725 27.7275 31.125 32.5 31.125C37.2725 31.125 41.125 27.2725 41.125 22.5C41.125 17.7275 37.2725 13.875 32.5 13.875Z"
      fill="black"
    />
  </Icon>
);
export const CommentIcon = (props) => (
  <Icon
    {...props}
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3536 15.6464L16.2071 15.5H16H2C1.58354 15.5 1.23978 15.3577 0.941554 15.0594C0.642483 14.7604 0.5 14.4162 0.5 14V2C0.5 1.58379 0.642483 1.23962 0.941553 0.940553C1.23978 0.64233 1.58354 0.5 2 0.5H18C18.4163 0.5 18.7604 0.642223 19.0593 0.940429C19.3577 1.23939 19.5 1.5836 19.5 2V17.575C19.5 17.7231 19.4672 17.8139 19.4284 17.8733C19.3899 17.9323 19.322 17.9963 19.1912 18.0523L19.1909 18.0525C19.0597 18.1088 18.9694 18.1122 18.9051 18.0997C18.8406 18.0872 18.7566 18.0495 18.6536 17.9464L16.3536 15.6464Z"
      stroke="black"
    />
  </Icon>
);
export const CommentBlackIcon = (props) => (
  <Icon
    {...props}
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3 18.3L16 16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H18C18.55 0 19.021 0.195667 19.413 0.587C19.8043 0.979 20 1.45 20 2V17.575C20 18.025 19.796 18.3373 19.388 18.512C18.9793 18.6873 18.6167 18.6167 18.3 18.3Z"
      fill="black"
    />
  </Icon>
);

export const Loader = (props) => (
  <Icon
    {...props}
    style={{
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto",
    }}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke={props.color ? props.color : "#fff"}
      stroke-width="10"
      r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
      ></animateTransform>
    </circle>
  </Icon>
);

export const ForwardIcon = (props) => (
  <Icon
    {...props}
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.2697 23.6911V46.5284C51.2697 47.7989 52.7614 48.4929 53.7438 47.6777L64.4586 38.7855C64.8019 38.5004 65 38.079 65 37.6344V5.17004C65 2.31384 62.6703 8.74945e-07 59.7981 8.74945e-07H51.2705L26.9729 0.000891798C26.626 0.000891798 26.2952 0.154132 26.0729 0.418728L16.5654 11.7325C15.928 12.4915 16.4704 13.6435 17.4654 13.6435H41.9673L0.931161 54.4258C-0.310387 55.6597 -0.310387 57.6608 0.931161 58.8965L6.14111 64.0745C7.38266 65.3085 9.39609 65.3085 10.6394 64.0745L51.2697 23.6911Z"
      fill="black"
    />
  </Icon>
);
